import { Component, OnInit, Input } from '@angular/core';
import { TermsAndConditions } from '../constants/TermsAndConditions';
import { JllTermsAndConditions } from '../constants/JllTermsAndConditions';
import { TermsConditionOptions } from '../terms-condition-options.interface';
import { TermsConditionService } from '../terms-condition.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.less']
})
export class TermsConditionComponent implements OnInit {

  termsAndConditionString: any;
  dataString: any;

  constructor(public termsConditionService: TermsConditionService) { }
  
  @Input()
  set options(opt: TermsConditionOptions) {
    this.attachChanges(opt);
  }

  @Input() set featureObject(value) {
    this.termsConditionService.featureObject = value;
  }

  // Attach all the changes received in the options object
  attachChanges(options): void {
    Object.keys(options).forEach(a => {
     if (this.termsConditionService.hasOwnProperty(a)) this.termsConditionService[a] = options[a]
    });
  }

  ngOnInit() {
    if (this.termsConditionService.isJLLSite()) {
      this.termsAndConditionString = JllTermsAndConditions;
    } else {
      this.termsAndConditionString = TermsAndConditions;
    }
  }

  closeTermsPopup() {
    (<any>window).Events.publish('closeTermsPopup');
  }

  stopProp(e) {
    e.stopPropagation();
  }

  ngOnDestroy() {
    this.termsAndConditionString = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/terms-condition/terms-condition/terms-condition.component.ts